import React from 'react'

const Missing = () => {
  return (
    <main className='text-center p-3'>
        <h1 >OOPs..</h1>
        <h3 >Someting Wrong!..Please Back to home </h3>
        
    </main>
  )
}

export default Missing